// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1OeIz","content":"styles_content__Ie5xN","checkbox":"styles_checkbox__1OirR","checkboxLabel":"styles_checkboxLabel__1lgp6"};